export default "https://cdn-static.gokick.com/assets/2b3e6896c425e2cf7d1a83db5abe7919e5484d77/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";